import request from 'superagent'
import types from '../types'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
  apiUrl = `${protocol}//${hostname}/api`
}

const getProviderApplicationRequested = () => ({
  type: types.GET_PROVIDER_APPLICATION_REQUESTED,
  payload: null
})

const getProviderApplicationFulfilled = (data: any) => ({
  type: types.GET_PROVIDER_APPLICATION_FULFILLED,
  payload: data
})

const getProviderApplicationRejected = (error: any) => ({
  type: types.GET_PROVIDER_APPLICATION_REJECTED,
  payload: error
})

export const getProviderApplication = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getProviderApplicationRequested())
    request
      .get(`${apiUrl}/providerApplication/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        dispatch(getProviderApplicationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getProviderApplicationRejected(error))
      })
  }
}

const addProviderApplicationRequested = () => ({
  type: types.ADD_PROVIDER_APPLICATION_REQUESTED,
  payload: null
})

const addProviderApplicationFulfilled = (data: any) => ({
  type: types.ADD_PROVIDER_APPLICATION_FULFILLED,
  payload: data
})

const addProviderApplicationRejected = (error: any) => ({
  type: types.ADD_PROVIDER_APPLICATION_REJECTED,
  payload: error
})

export const addProviderApplication = (data: { applicationType: string; '12BedCertification': string }, id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(addProviderApplicationRequested())
    request
      .post(`${apiUrl}/providerApplication/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(addProviderApplicationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(addProviderApplicationRejected(error))
      })
  }
}

const updateProviderApplicationGeneralInfoRequested = () => ({
  type: types.UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_REQUESTED,
  payload: null
})

const updateProviderApplicationGeneralInfoRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_REJECTED,
  payload: error
})

const updateProviderApplicationGeneralInfoFulfilled = (data: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_FULFILLED,
  payload: data
})

export const updateProviderApplicationGeneralInfo = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateProviderApplicationGeneralInfoRequested())
    request
      .put(`${apiUrl}/providerApplication/generalInfo/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateProviderApplicationGeneralInfoFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateProviderApplicationGeneralInfoRejected(error))
      })
  }
}

const updateProviderApplicationContactInfoRequested = () => ({
  type: types.UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_REQUESTED,
  payload: null
})

const updateProviderApplicationContactInfoRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_REJECTED,
  payload: error
})

const updateProviderApplicationContactInfoFulfilled = (data: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_FULFILLED,
  payload: data
})

export const updateProviderApplicationContactInfo = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateProviderApplicationContactInfoRequested())
    request
      .put(`${apiUrl}/providerApplication/contactInfo/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateProviderApplicationContactInfoFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateProviderApplicationContactInfoRejected(error))
      })
  }
}

const updateProviderApplicationOrgInfoRequested = () => ({
  type: types.UPDATE_PROVIDER_APPLICATION_ORG_INFO_REQUESTED,
  payload: null
})

const updateProviderApplicationOrgInfoRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_ORG_INFO_REJECTED,
  payload: error
})

const updateProviderApplicationOrgInfoFulfilled = (data: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_ORG_INFO_FULFILLED,
  payload: data
})

export const updateProviderApplicationOrgInfo = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateProviderApplicationOrgInfoRequested())
    request
      .put(`${apiUrl}/providerApplication/organizationalInfo/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateProviderApplicationOrgInfoFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateProviderApplicationOrgInfoRejected(error))
      })
  }
}

const updateProviderApplicationDisclosureQuestionsRequested = () => ({
  type: types.UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_REQUESTED,
  payload: null
})

const updateProviderApplicationDisclosureQuestionsRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_REJECTED,
  payload: error
})

const updateProviderApplicationDisclosureQuestionsFulfilled = (data: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_FULFILLED,
  payload: data
})

export const updateProviderApplicationDisclosureQuestions = (token: string, id: number, data: any, submitItem: boolean) => {
  return (dispatch: any) => {
    dispatch(updateProviderApplicationDisclosureQuestionsRequested())
    request
      .put(`${apiUrl}/providerApplication/disclosureQuestions/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send({
        ...data,
        submitItem
      })
      .then((response) => {
        dispatch(updateProviderApplicationDisclosureQuestionsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateProviderApplicationDisclosureQuestionsRejected(error))
      })
  }
}

const updateProviderApplicationItemRequested = () => ({
  type: types.UPDATE_PROVIDER_APPLICATION_ITEM_REQUESTED,
  payload: null
})

const updateProviderApplicationItemRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_ITEM_REJECTED,
  payload: error
})

const updateProviderApplicationItemFulfilled = (data: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_ITEM_FULFILLED,
  payload: data
})

export const updateProviderApplicationItem = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateProviderApplicationItemRequested())
    request
      .put(`${apiUrl}/providerApplicationItem/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateProviderApplicationItemFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateProviderApplicationItemRejected(error))
      })
  }
}

const updateProviderApplicationCertificationRequested = () => ({
  type: types.UPDATE_PROVIDER_APPLICATION_CERTIFICATION_REQUESTED,
  payload: null
})

const updateProviderApplicationCertificationRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_CERTIFICATION_REJECTED,
  payload: error
})

const updateProviderApplicationCertificationFulfilled = (data: any) => ({
  type: types.UPDATE_PROVIDER_APPLICATION_CERTIFICATION_FULFILLED,
  payload: data
})

export const updateProviderApplicationCertification = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateProviderApplicationCertificationRequested())
    request
      .put(`${apiUrl}/providerApplicationCertification/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateProviderApplicationCertificationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateProviderApplicationCertificationRejected(error))
      })
  }
}

const submitProviderApplicationRequested = () => ({
  type: types.SUBMIT_PROVIDER_APPLICATION_REQUESTED,
  payload: null
})

const submitProviderApplicationRejected = (error: any) => ({
  type: types.SUBMIT_PROVIDER_APPLICATION_REJECTED,
  payload: error
})

const submitProviderApplicationFulfilled = (data: any) => ({
  type: types.SUBMIT_PROVIDER_APPLICATION_FULFILLED,
  payload: data
})

export const submitProviderApplication = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(submitProviderApplicationRequested())
    request
      .post(`${apiUrl}/providerApplication/submit/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(submitProviderApplicationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(submitProviderApplicationRejected(error))
      })
  }
}

const submitCertificationItemsRequested = () => ({
  type: types.SUBMIT_CERTIFICATION_ITEMS_REQUESTED,
  payload: null
})

const submitCertificationItemsRejected = (error: any) => ({
  type: types.SUBMIT_CERTIFICATION_ITEMS_REJECTED,
  payload: error
})

const submitCertificationItemsFulfilled = (data: any) => ({
  type: types.SUBMIT_CERTIFICATION_ITEMS_FULFILLED,
  payload: data
})

export const submitCertificationItems = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(submitCertificationItemsRequested())
    request
      .post(`${apiUrl}/providerApplicationCertification/submit/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(submitCertificationItemsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(submitCertificationItemsRejected(error))
      })
  }
}